// extracted by mini-css-extract-plugin
module.exports = {"contentStrip":"DataStrip_contentStrip__ye9Wb","fullBleed":"DataStrip_fullBleed__P9ajE"};